export const fileRights = {
	selector: {
		expandCaret: '.js-directory-expand',
		fileManagerSection: '.js-file-manager-section',
	},
	attribute: {
		blockId: 'data-block-id',
		path: 'data-path',
		url: 'data-url',
		level: 'data-level',
	},
}
